import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Landmark from 'components/Landmark';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import useCustomContactLink from 'hooks/useCustomContactLink';
function ContactLink(_ref) {
  var children = _ref.children;
  var contactLink = useCustomContactLink();
  if (contactLink.url) {
    return /*#__PURE__*/React.createElement(TextLink, {
      href: contactLink.url,
      target: "_blank"
    }, children);
  }
  return /*#__PURE__*/React.createElement(TextLink, {
    as: "button",
    onClick: contactLink.openModal
  }, children);
}
function NoSkillsNote() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Landmark, null, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "error_no_skills_found"
  }, "No skills were found. If you think this is an error, please", /*#__PURE__*/React.createElement(ContactLink, null, "let us know"), ".")));
}
export default NoSkillsNote;